<template>
  <div class="html-email-template-example">
              <iframe :srcdoc="parsedContent" width="100%" onload="this.style.height=(this.contentWindow.document.body.scrollHeight+20)+'px';"/>
          </div>
</template>

<script>
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';

const moment = require('moment');

export default {
  name: 'HTMLEmailTemplateExampleComponent',
  props: {
    templateContent: {
      type: String,
      required: true,
    }
  },
  data() {
    return {};
  },
  mounted() {},
    computed: {
    parsedContent() {
      const titelRegex = /{{ \$title.*}}/ig
      const contentRegex = /{{ \$content.*}}/ig
      let content = this.templateContent
      content = content.replaceAll(titelRegex, 'Test titel')
      content = content.replaceAll(contentRegex, 'Deze tekst staat hier ter illustratie')

      return content
    },
    wrapperCol() {
      switch (this.$mq) {
        case 'mobile':
          return {span: 18};
        case 'tablet':
          return {span: 18};
        case 'laptop':
          return {span: 18};
        case 'desktop':
          return {span: 18};
      }
    },
  },
};
</script>
<style>
/* required class */
.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: ghostwhite;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example: */
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}
</style>